module.exports = __webpack_public_path__ + "img/personality-profiles.bcc0e440.svg";